/**
 * Prefix of content types
 */
// eslint-disable-next-line etc/no-const-enum
export var ContentTypePrefix;
(function (ContentTypePrefix) {
    /**
     * Text type prefix
     */
    ContentTypePrefix["Text"] = "text/";
    /**
     * Image type prefix
     */
    ContentTypePrefix["Image"] = "image/";
})(ContentTypePrefix || (ContentTypePrefix = {}));
/**
 * Known content types
 */
// eslint-disable-next-line etc/no-const-enum
export var ContentType;
(function (ContentType) {
    /**
     * Plain text content type
     */
    ContentType["PlainText"] = "text/plain";
    /**
     * HTML content type
     */
    ContentType["HTML"] = "text/html";
})(ContentType || (ContentType = {}));
//# sourceMappingURL=ContentType.js.map